module.exports = __webpack_public_path__ + "static/media/error-file.48732be4.svg";